import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className, ...props }: InputProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-sm text-tg-text-secondary">{label}</label>}
      <input
        className={clsx(
          'w-full rounded-md border border-tg-border px-3 py-2 text-sm text-tg-text outline-none transition-colors focus:border-tg-accent',
          error && 'border-tg-error',
          className
        )}
        style={{ background: 'var(--tg-bg-secondary)' }}
        {...props}
      />
      {error && <span className="text-xs text-tg-error">{error}</span>}
    </div>
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export function Textarea({ label, error, className, ...props }: TextareaProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-sm text-tg-text-secondary">{label}</label>}
      <textarea
        className={clsx(
          'w-full rounded-md border border-tg-border px-3 py-2 text-sm text-tg-text outline-none transition-colors focus:border-tg-accent resize-y min-h-[80px]',
          error && 'border-tg-error',
          className
        )}
        style={{ background: 'var(--tg-bg-secondary)' }}
        {...props}
      />
      {error && <span className="text-xs text-tg-error">{error}</span>}
    </div>
  );
}
